import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { Needsofthepopulation } from '../../../components/Grossharvestofproducts/Needsofthepopulation';

const NeedsofthepopulationPage: FC = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>Потребности населения</title>
            </Helmet>
            <Needsofthepopulation/>
        
        </>
    );
};

export default NeedsofthepopulationPage
